

export class AppError extends Error {
  constructor(message?: string, public code?: string, public originalError?: any) {
    super(message);
  }
}

export class AppErrorTimeout extends AppError {
  constructor(message?: string) {
    super(message ?? 'Tempo de expera excedido para a operação');
  }
}
